import { call, put, takeLatest } from "redux-saga/effects";
import { GET_RoleList, GET_RoleDetail, POST_Role, PUT_Role, DELETE_Role, GET_RolePermissions } from "../services/Role";
import exception from "../utils/exception";
import { jwtDecode, jwtEncode } from "../utils/jwt";
import { getToken } from "../utils/token";

function* GET_RoleListEffect({ callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    const res = yield call(GET_RoleList, token);
    const resData = yield call(jwtDecode, res.data);
    yield put({ type: "SAVE_RoleList", payload: resData.data });
    if (callback) callback();
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

function* GET_RoleDetailEffect({ payload, callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    const data = yield call(jwtEncode, payload);
    const query = { Data: data };
    const res = yield call(GET_RoleDetail, token, query);
    const resData = yield call(jwtDecode, res.data);
    yield put({ type: "SAVE_RoleDetail", payload: resData.data });
    if (callback) callback();
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

function* POST_RoleEffect({ payload, callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    const formData = new FormData();
    const data = yield call(jwtEncode, payload);
    formData.append("data", data);
    yield call(POST_Role, token, formData);
    if (callback) callback();
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

function* PUT_RoleEffect({ payload, callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    const formData = new FormData();
    const data = yield call(jwtEncode, payload);
    formData.append("data", data);
    yield call(PUT_Role, token, formData);
    if (callback) callback();
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

function* DELETE_RoleEffect({ payload, callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    const data = yield call(jwtEncode, payload);
    const query = { Data: data };
    yield call(DELETE_Role, token, query);
    if (callback) callback();
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

function* GET_RolePermissionsEffect({ callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    const res = yield call(GET_RolePermissions, token);
    const resData = yield call(jwtDecode, res.data);
    yield put({ type: "SAVE_RolePermissions", payload: resData.data });
    if (callback) callback();
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

export default function* Example() {
  yield takeLatest("GET_RoleList", GET_RoleListEffect);
  yield takeLatest("GET_RoleDetail", GET_RoleDetailEffect);
  yield takeLatest("POST_Role", POST_RoleEffect);
  yield takeLatest("PUT_Role", PUT_RoleEffect);
  yield takeLatest("DELETE_Role", DELETE_RoleEffect);
  yield takeLatest("GET_RolePermissions", GET_RolePermissionsEffect);
}
